var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import ShowIf from "../../App/ShowIf";
import { DocumentLanguage, TemplateLabel } from "../../Layout";
import { Icon } from "../../Layout/Icon";
import TimelineViewer from "../../Timeline/components/TimelineViewer";
import { caseTemplate, matterTemplate } from "../../Timeline/utils/timelineFixedData";
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormatMetadata } from "../containers/FormatMetadata";

export class ShowMetadata extends Component {
  render() {
    const { entity, showTitle, showType, relationships, showSubset, groupGeolocations } =
    this.props;
    let header = '';
    if (showTitle || showType) {
      let title = '';
      if (showTitle) {
        title = /*#__PURE__*/
        _jsx("div", {}, void 0, /*#__PURE__*/
        _jsx(Icon, { className: "item-icon item-icon-center", data: entity.icon }), /*#__PURE__*/
        _jsx("h1", { className: "item-name" }, void 0,
        entity.title, /*#__PURE__*/
        _jsx(DocumentLanguage, { doc: Immutable.fromJS(entity) })));



      }
      const type = showType ? /*#__PURE__*/_jsx(TemplateLabel, { template: entity.template }) : '';
      header = /*#__PURE__*/
      _jsx("div", { className: "item-info" }, void 0,
      title,
      type);


    }

    return /*#__PURE__*/(
      _jsx("div", { className: "view" }, void 0,
      header, /*#__PURE__*/

      _jsx(ShowIf, { if: entity.template === caseTemplate || entity.template === matterTemplate }, void 0, /*#__PURE__*/
      _jsx("dl", { className: "metadata-timeline-viewer" }, void 0, /*#__PURE__*/
      _jsx("dd", {}, void 0, /*#__PURE__*/
      _jsx(TimelineViewer, { entity: entity })))), /*#__PURE__*/



      _jsx(FormatMetadata, {
        entity: entity,
        relationships: relationships,
        showSubset: showSubset,
        groupGeolocations: groupGeolocations,
        renderLabel: (prop, label) => !prop.noLabel && label })));



  }
}
ShowMetadata.defaultProps = {
  showSubset: undefined,
  groupGeolocations: false
};











const mapStateToProps = ({ templates }) => ({ templates });

export default connect(mapStateToProps)(ShowMetadata);